import { render, staticRenderFns } from "./EventsScorePreview.vue?vue&type=template&id=59a64c39"
import script from "./EventsScorePreview.vue?vue&type=script&lang=js"
export * from "./EventsScorePreview.vue?vue&type=script&lang=js"
import style0 from "./EventsScorePreview.vue?vue&type=style&index=0&id=59a64c39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports